import React from 'react';
import Header from './components/Header';
import EventsPage from './pages/events/EventsPage';
import EventDetailsPage from './pages/events/EventDetailsPage';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import CreateEventPage from './pages/events/CreateEventPage';
import RegisterUserPage from "./pages/user/RegisterUserPage";
import LoginPage from "./pages/user/LoginPage";
import ConfirmEmailPage from "./pages/user/ConfirmEmailPage";
import ForgotPasswordPage from "./pages/user/ForgotPasswordPage";
import ResetPasswordPage from "./pages/user/ResetPasswordPage";
import UserProfilePage from "./pages/user/UserProfilePage";
import UnauthorizedPage from "./pages/exceptions/UnauthorizedPage";
import PaymentReturnPage from "./pages/payment/PaymentReturnPage";
import LiveChatPage from './pages/LiveChat/LiveChatPage';
import AdminPage from './pages/admin/AdminPage';
import AdminUserTransactionsPage from './pages/admin/AdminUserTransactionsPage';

function App() {
    return (
        <Router>
            <div>
                <Header />
                <Routes>
                    <Route path="/events" element={<EventsPage />} />
                    <Route path="/events/:id" element={<EventDetailsPage />} />
                    <Route path="/events/create" element={<CreateEventPage />} />
                    <Route path="/register" element={<RegisterUserPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/confirm-email" element={<ConfirmEmailPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/profile" element={<UserProfilePage />} />
                    <Route path="/unauthorized" element={<UnauthorizedPage />} />
                    <Route path="/payment-return" element={<PaymentReturnPage />} />
                    <Route path='/chat' element={<LiveChatPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/admin/users/:id/transactions" element={<AdminUserTransactionsPage />} />
                </Routes>
            </div>
        </Router>
    );
}
export default App;


